import React from 'react';
import PropTypes from 'prop-types';
import { getContextualUrl } from '../scripts/utils';
import Link from './Link';
var LegalLinks = function LegalLinks(_ref) {
  var legalLinks = _ref.legalLinks,
    locale = _ref.locale,
    teamNameSlug = _ref.teamNameSlug,
    isLegacy = _ref.isLegacy;
  var getCurrentYear = function getCurrentYear() {
    return new Date().getFullYear();
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "site-footer__legal-links"
  }, /*#__PURE__*/React.createElement("ul", null, legalLinks.map(function (legalLink) {
    var link = legalLink.properties && legalLink.properties.link || '';
    var contextualLink = getContextualUrl(link, teamNameSlug, locale, isLegacy);
    return /*#__PURE__*/React.createElement("li", {
      key: "legalLink-".concat(legalLink.text)
    }, /*#__PURE__*/React.createElement(Link, {
      url: contextualLink,
      className: "site-footer__legal-link",
      text: legalLink.text,
      target: legalLink.properties.target
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "site-footer__copyright-container"
  }, "\xA9 ", getCurrentYear(), " MLB Advanced Media, LP. All rights reserved."));
};
export default LegalLinks;
LegalLinks.propTypes = {
  legalLinks: PropTypes.instanceOf(Array).isRequired,
  locale: PropTypes.string,
  teamNameSlug: PropTypes.string,
  isLegacy: PropTypes.bool
};
LegalLinks.defaultProps = {
  legalLinks: [],
  locale: 'en',
  teamNameSlug: '',
  isLegacy: false
};